/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.160.1-v202607082044-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqDatafilesApiClass {
 
   constructor() {}

  /**
   * @summary Archive a datafile and all of its signals
   * @param {string} id - ID of the datafile to archive
  */
  public archiveDatafile(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datafiles/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Create a datafile
  */
  public createDatafile(
    body: models.DatafileInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datafiles`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.DatafileOutputV1>;
  }

  /**
   * @summary Get a Datafile
   * @param {string} id - ID of the datafile to retrieve
  */
  public getDatafile(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datafiles/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.DatafileOutputV1>;
  }

  /**
   * @summary Get a collection of datafiles
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
  */
  public getDatafiles(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datafiles`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemPreviewListV1>;
  }

  /**
   * @summary Get a list of the items hosted by this datafile
   * @param {string} id - ID of the datafile
   * @param {string} [dataId] - The dataId for a specific hosted item
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
  */
  public getItemsHostedByDatafile(
    {
      id,
      dataId,
      offset,
      limit
    } : {
      id: string,
      dataId?: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datafiles/${encodeURIComponent(String(id))}/items`
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['dataId']: dataId,      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemPreviewListV1>;
  }

  /**
   * @summary Import a CSV file that can be used to create or update a Datafile
   * @param {Blob} [file]
  */
  public importCSV(
    {
      file
    } : {
      file?: File
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datafiles/csv`;


    const formData = new FormData();
    formData.append('file', file as File, file?.name);

    return axiosInstance.request({
      method: 'post',
      url,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      ...restOverrides
    }) as AxiosPromise<models.CsvDatafileOutputV1>;

    return axiosInstance.request({
      method: 'post',
      url,
      ...restOverrides
    }) as AxiosPromise<models.CsvDatafileOutputV1>;
  }

  /**
   * @summary Update a datafile
   * @param {string} id - ID of the datafile to retrieve
  */
  public updateDatafile(
    body: models.DatafileInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/datafiles/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.DatafileOutputV1>;
  }

}


export const sqDatafilesApi = new sqDatafilesApiClass();

export type sqDatafilesApiEndpoints = {
  'archiveDatafile': {
    method: 'delete';
    path: '/datafiles/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'createDatafile': {
    method: 'post';
    path: '/datafiles';
    response: models.DatafileOutputV1;
  };
  'getDatafile': {
    method: 'get';
    path: '/datafiles/${encodeURIComponent(String(id))}';
    response: models.DatafileOutputV1;
  };
  'getDatafiles': {
    method: 'get';
    path: '/datafiles';
    response: models.ItemPreviewListV1;
  };
  'getItemsHostedByDatafile': {
    method: 'get';
    path: '/datafiles/${encodeURIComponent(String(id))}/items';
    response: models.ItemPreviewListV1;
  };
  'importCSV': {
    method: 'post';
    path: '/datafiles/csv';
    response: models.CsvDatafileOutputV1;
  };
  'updateDatafile': {
    method: 'post';
    path: '/datafiles/${encodeURIComponent(String(id))}';
    response: models.DatafileOutputV1;
  };
};

type ApiArchiveDatafileResponse = models.StatusMessageBase;
type ApiarchiveDatafileMutationParams = Parameters<typeof sqDatafilesApi.archiveDatafile> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDatafilesApi.archiveDatafile>;

export function useApiArchiveDatafileMutation(
  options?: Omit<UseMutationOptions<ApiArchiveDatafileResponse, AxiosError<SeeqErrorData>,
    ApiarchiveDatafileMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiArchiveDatafileResponse, AxiosError<SeeqErrorData>,
  ApiarchiveDatafileMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiarchiveDatafileMutationParams) =>
      sqDatafilesApi.archiveDatafile(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateDatafileResponse = models.DatafileOutputV1;
type ApicreateDatafileMutationParams = Parameters<typeof sqDatafilesApi.createDatafile> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDatafilesApi.createDatafile>;
type ApicreateDatafileMutationVariables = models.DatafileInputV1;

export function useApiCreateDatafileMutation(
  options?: Omit<UseMutationOptions<ApiCreateDatafileResponse, AxiosError<SeeqErrorData>,
    ApicreateDatafileMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateDatafileResponse, AxiosError<SeeqErrorData>,
  ApicreateDatafileMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateDatafileMutationVariables) =>
      sqDatafilesApi.createDatafile(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetDatafileResponse = models.DatafileOutputV1;
export function GetDatafileQueryKey(
  params: Parameters<typeof sqDatafilesApi.getDatafile>[0],
) {
  return ['sqDatafilesApi', 'getDatafile', params] as const;
}

export function useApiGetDatafileQuery(
  params: Parameters<typeof sqDatafilesApi.getDatafile>[0],
  options?: Omit<UseQueryOptions<ApiGetDatafileResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetDatafileResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetDatafileQueryKey(params),
    queryFn: () =>
      sqDatafilesApi.getDatafile(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetDatafilesResponse = models.ItemPreviewListV1;
export function GetDatafilesQueryKey(
  params: Parameters<typeof sqDatafilesApi.getDatafiles>[0],
) {
  return ['sqDatafilesApi', 'getDatafiles', params] as const;
}

export function useApiGetDatafilesQuery(
  params: Parameters<typeof sqDatafilesApi.getDatafiles>[0],
  options?: Omit<UseQueryOptions<ApiGetDatafilesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetDatafilesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetDatafilesQueryKey(params),
    queryFn: () =>
      sqDatafilesApi.getDatafiles(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetItemsHostedByDatafileResponse = models.ItemPreviewListV1;
export function GetItemsHostedByDatafileQueryKey(
  params: Parameters<typeof sqDatafilesApi.getItemsHostedByDatafile>[0],
) {
  return ['sqDatafilesApi', 'getItemsHostedByDatafile', params] as const;
}

export function useApiGetItemsHostedByDatafileQuery(
  params: Parameters<typeof sqDatafilesApi.getItemsHostedByDatafile>[0],
  options?: Omit<UseQueryOptions<ApiGetItemsHostedByDatafileResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetItemsHostedByDatafileResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetItemsHostedByDatafileQueryKey(params),
    queryFn: () =>
      sqDatafilesApi.getItemsHostedByDatafile(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiImportCSVResponse = models.CsvDatafileOutputV1;
type ApiimportCSVMutationParams = Parameters<typeof sqDatafilesApi.importCSV> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDatafilesApi.importCSV>;

export function useApiImportCSVMutation(
  options?: Omit<UseMutationOptions<ApiImportCSVResponse, AxiosError<SeeqErrorData>,
    ApiimportCSVMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiImportCSVResponse, AxiosError<SeeqErrorData>,
  ApiimportCSVMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiimportCSVMutationParams) =>
      sqDatafilesApi.importCSV(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateDatafileResponse = models.DatafileOutputV1;
type ApiupdateDatafileMutationParams = Parameters<typeof sqDatafilesApi.updateDatafile> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDatafilesApi.updateDatafile>;

export function useApiUpdateDatafileMutation(
  options?: Omit<UseMutationOptions<ApiUpdateDatafileResponse, AxiosError<SeeqErrorData>,
    ApiupdateDatafileMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateDatafileResponse, AxiosError<SeeqErrorData>,
  ApiupdateDatafileMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateDatafileMutationParams) =>
      sqDatafilesApi.updateDatafile(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
